export default "__VITE_ASSET__LWYzz3I2__"